// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2qv9P","sendOtp":"AuthorizeToLogin_sendOtp__ZRsdR"};